import { useMutation } from '@tanstack/react-query';
import { driverApi } from '../services/driverApi';
import { useHybridAuth } from './useHybridAuth';

/** Why a delete was refused, in words for the person who asked. */
export function deleteRefusal(error: unknown): string {
  return (error as { status?: number } | null)?.status === 409
    ? 'You own a company. Make someone else the owner, or cancel the company, from the dashboard first.'
    : 'Your account could not be deleted. Try again, or contact support.';
}

/**
 * Delete the signed-in member's account (DELETE /auth/me), which Apple
 * requires an app to offer. Signs out once it is gone.
 */
export const useDeleteAccount = () => {
  const { getAccessTokenSilently, logout } = useHybridAuth();
  return useMutation({
    mutationFn: async () => {
      driverApi.setAuthToken(await getAccessTokenSilently());
      await driverApi.deleteAccount();
    },
    onSuccess: () => logout(),
  });
};
